module.exports = __webpack_public_path__ + "DINNextRoundedLTPro-Medium.woff2?0c8da24ae7ef3d7190badc0bef08e266";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextRoundedLTPro-Medium.woff2
// module id = 1406
// module chunks = 0